// extracted by mini-css-extract-plugin
export var currencyInput = "_jf-1";
export var currencySymbol = "_jf-0";